





























import { Component, Vue, Prop } from 'vue-property-decorator'
import CreateServiceForm, { CreateServiceFormValue } from '../form/CreateServiceForm.vue'


@Component({
    components: {
        'create-service-form': CreateServiceForm
    }
})
export default class CreateServiceModal extends Vue {
    @Prop({required: true})
    value!: CreateServiceFormValue

    previewUrl: string | null = null

    createServiceForm: CreateServiceFormValue | null = null


    get validEditForm() {
        return CreateServiceForm.valid(this.value)
    }

    mounted() {
        if (this.value.file) {
            this.previewUrl = window.URL.createObjectURL(this.value.file)
        }
        this.createServiceForm = {...this.value}
    }

    updateForm() {
        this.$emit("input", this.createServiceForm)
    }

}
